export const calculateTimeSince = (dateTimeString: string): string => {
  const date = new Date(dateTimeString);
  const now = new Date();
  const diff = Math.abs(now.getTime() - date.getTime());
  const msToHours = 1000 * 60 * 60;

  // if less than 24h, X hours ago
  if (diff < msToHours * 24) {
    const hours = Math.floor(diff / msToHours);
    if (hours === 0) {
      return '1 hour ago';
    } else {
      return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    }
  }

  // if less than 14 days, X days ago
  if (diff < msToHours * 24 * 14) {
    const days = Math.floor(diff / (msToHours * 24));
    return `${days} day${days > 1 ? 's' : ''} ago`;
  }

  // else X weeks ago
  const weeks = Math.floor(diff / (msToHours * 24 * 7));
  return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
};
